import React from "react";
import styled from "styled-components";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  readyToHireText: {
    id: "TaskTemplateServiceBreadcrumbs.readyToHireText",
    defaultMessage: "Ready to hire a Tasker?",
  },
});

export default function ReadyToHireHeader() {
  const { formatMessage } = useIntl();
  return (
    <Container>
      <span>{formatMessage(messages.readyToHireText)}</span>
    </Container>
  );
}

const Container = styled.div`
  font-size: ${(p) => p.theme.typography.typeScale[400]};
  font-weight: ${(p) => p.theme.typography.weight.extraBold};
  margin-bottom: 1rem;

  @media (max-width: 800px) {
    margin-top: 1rem;
    font-size: 1.5rem;
  }
`;
